import { useRouterState } from '@tanstack/react-router'
import { isTauri } from '../lib/platform.ts'

/**
 * Mac app: invisible strip along the top edge of the window. The title bar is hidden (Overlay), so this
 * lets the window be dragged from anywhere along the top edge; double-click zooms like a native title bar.
 */
export function WindowDragStrip() {
  const path = useRouterState({ select: (s) => s.location.pathname })
  if (!isTauri || path.startsWith('/quick-capture')) return null
  return <div data-tauri-drag-region aria-hidden className="fixed inset-x-0 top-0 z-[60] h-4" />
}
